import { useEffect, useState } from "react";
import { Bell, AlertTriangle, AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { toast } from "sonner";

export default function AlertBell() {
  const [alerts, setAlerts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try { const { data } = await api.get("/evidence-alerts"); if (!cancelled) setAlerts(data); } catch { /* sin alertas */ }
    })();
    const t = setInterval(async () => {
      try { const { data } = await api.get("/evidence-alerts"); setAlerts(data); } catch { /* reintento */ }
    }, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const count = alerts.length;

  const dismissAll = async () => {
    try {
      await Promise.all(alerts.map((a) => api.post(`/evidence-alerts/${a.id}/dismiss`)));
      toast.success("Alertas descartadas.");
      setAlerts([]);
    } catch { /* ignore */ }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="alert-bell" className="relative inline-flex items-center justify-center h-8 w-8 rounded-md hover:bg-slate-100">
        <Bell className="h-4 w-4 text-slate-600" />
        {count > 0 && (
          <span className="absolute -top-0.5 -right-0.5 bg-destructive text-white text-[10px] rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
            {count > 9 ? "9+" : count}
          </span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <div className="text-[12px] uppercase tracking-wide text-slate-400 px-2 py-1.5">Alertas de evidencias</div>
        {count === 0 && <div className="text-[13px] text-slate-500 px-2 py-3">No tienes alertas pendientes.</div>}
        {alerts.slice(0, 10).map((a) => (
          <DropdownMenuItem key={a.id} onClick={() => navigate(`/evidences/${a.evidence_id}`)} className="flex-col items-start gap-0.5 py-2" data-testid={`alert-${a.id}`}>
            <div className="flex items-center gap-2 text-[13px]">
              {a.alert_type === "expired" ? <AlertCircle className="h-3.5 w-3.5 text-red-600" /> : <AlertTriangle className="h-3.5 w-3.5 text-amber-600" />}
              <span className="font-medium">{a.alert_type === "expired" ? "Caducada" : "Próxima a caducar"}</span>
            </div>
            <div className="text-[11px] text-slate-500 ml-5">Evidencia {a.evidence_id.slice(0, 8)}… · {new Date(a.triggered_at).toLocaleDateString("es-ES")}</div>
          </DropdownMenuItem>
        ))}
        {count > 0 && (
          <DropdownMenuItem onSelect={(e) => { e.preventDefault(); dismissAll(); }} className="justify-center text-primary text-[12px]" data-testid="dismiss-all">
            Descartar todas
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
